<script>
    import jQuery from "jquery";
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc('gp-itemlist');

    export let project;


   export function open() {
       jQuery('#GPItemList #saveItemList').off().on("click",() => download(jQuery("#GPItemList table")[0].innerText, "plantList.txt", "text/plain"));

       //trap focus
       jQuery('#GPItemList .close').on('keydown', function(e) {if (e.shiftKey && e.which===9) e.preventDefault();});
       jQuery('#GPItemList #saveItemList').on('keydown', function(e) {if (!e.shiftKey && e.which===9) e.preventDefault();});

        jQuery('#GPItemList').modal({});
        jQuery('#GPItemList').on('hidden.bs.modal', () => this.$destroy());
   }

    function download(data, filename, type) {
        var a = document.createElement("a"),
            file = new Blob([data], {type: type});
        if (window.navigator.msSaveOrOpenBlob) // IE10+
            window.navigator.msSaveOrOpenBlob(file, filename);
        else { // Others
            var url = URL.createObjectURL(file);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function() {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
    }

</script>


<div class="modal fade GPModal" tabindex="-1" id="GPItemList">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{trans("Items used in this project")}</h4>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <table>
                        <tr>
                            <th>
                                {trans("Name")}
                            </th>
                            <th>
                                {trans("Quantity")}
                            </th>
                        </tr>
                        {#each project.plantTypes() as item}
                                <tr><td>{item.name}</td><td>{item.count}</td></tr>
                        {/each}
                    </table>
                </div>
                <button id="saveItemList" class="btn btn-default">{trans("Save")}</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->